import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TooltipPosition } from '@angular/material/tooltip';
import { HelpTextComponent } from 'src/app/component/common-components/help-text/help-text.component';
import { UserModel } from '../../model/user';

import { AccountService } from '../../service/account.service';

@Component({
    selector: 'app-view-account',
    templateUrl: './view-account.component.html',
    styleUrls: ['./view-account.component.scss']
})
export class ViewAccountComponent implements OnInit {
    step = 0;
    positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
    loginDetailStatusName: string = '';
    constructor(
        public accountService: AccountService,
        public dialogRef: MatDialogRef<ViewAccountComponent>,
        @Inject(MAT_DIALOG_DATA) public user: UserModel,
        private dialog: MatDialog
    ) {
        this.loginDetailStatusName =
            this.user.LOGIN_DETAIL_STATUS == null ||
            this.user.LOGIN_DETAIL_STATUS.length <= 0 ||
            this.user.LOGIN_DETAIL_STATUS[0].LOGIN_DETAIL_STATUS_TYPES == null ||
            this.user.LOGIN_DETAIL_STATUS[0].LOGIN_DETAIL_STATUS_TYPES.NAME == null
                ? ''
                : this.user.LOGIN_DETAIL_STATUS[0]?.LOGIN_DETAIL_STATUS_TYPES?.NAME?.toString();
    }

    ngOnInit(): void {}

    displayHelpText() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.maxHeight = '80vh';
        dialogConfig.data = this.user.LOGIN_DETAIL_STATUS[0].DESCRIPTION;
        const dialogRef = this.dialog.open(HelpTextComponent, dialogConfig);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    setStep(index: number) {
        this.step = index;
    }

    nextStep() {
        this.step++;
    }

    prevStep() {
        this.step--;
    }
}
